        
        //</meta> <link href="css/bootstrap.css" rel='stylesheet' type='text/css' /><!-- bootstrap css -->
        //</head> <link href="css/style.css" rel='stylesheet' type='text/css' /><!-- custom css -->
        //</html>  <link href="css/font-awesome.min.css" rel="stylesheet"><!-- fontawesome css -->
        
        //<link href="//fonts.googleapis.com/css?family=Cabin:400,400i,500,500i,600,600i,700,700i&amp;subset=latin-ext,vietnamese" rel="stylesheet">
        
        import React,{Component} from 'react';
       
         import register from './registerComponent';
         import Login from './LoginComponent';
         import forgotPasswordComponent from './forgotPasswordComponent';
         import changePasswordComponent from './changePasswordComponent';
         import landingComponent from './landingComponent';
         import dashboardComponent from './dashboardComponent';
         import updatesComponent from './updates';
         import UpdatesIsssuesComponent from './updateIssues';
        // import singleComponent from './singlePage';
        //<Route exact path="/search/view/:id" component={singleComponent}></Route>    
         import verifyEmailComponent from './verifyEmailComponent';
         import DeleteIsssuesComponent from './DeleteIsssuesComponent';
         import DeleteUsersComponent from './DeleteUsersComponent';
         import DeleteOrgsComponent from './DeleteOrgsComponent';

         import IssuesViewComponent from './IssuesViewComponent';

         import UsersEventsViewComponent from './UsersEventsViewComponent';
         import UsersReposViewComponent from './UsersReposViewComponent';
         import UsersGistsViewComponent from './UsersGistsViewComponent';

         import OrgsEventsViewComponent from './OrgsEventsViewComponent';
         import OrgsReposViewComponent from './OrgsReposViewComponent';


         import OrgsPublicEventsViewComponent from "./OrgsPublicEventsViewComponent";
         import IssuesPublicViewComponent from "./IssuesPublicViewComponent";
         import OrgsPublicReposViewComponent from "./OrgsPublicReposViewComponent";
         import UserPublicReposViewComponent from "./UserPublicReposViewComponent";
         import UsersPublicGistsViewComponent from "./UsersPublicGistsViewComponent";
         import UsersPublicEventsViewComponents from "./UsersPublicEventsViewComponents";
 

         import {BrowserRouter,Route,Link} from 'react-router-dom';
        //import {BrowserRouter,Route,Link,NavLink,withRouter} from 'react-router-dom';
        import axios from "axios";
         
        class App extends Component{
        
        	constructor(props)
        	{
        		super(props)
        		
        		this.state = {
                    firstName: null,
                    lastName: null,
                    middleName: null,
                    footerYear: 2019,
                    loggedInStatus: null,
                    loadingPersonal:false,
                    yearDate:2019
        		}
        
                this.handleFirstName = this.handleFirstName.bind(this);
                this.handleLastName = this.handleLastName.bind(this);
                this.handleMiddleName = this.handleMiddleName.bind(this);
                //this.handleGithubUsername = this.handleGithubUsername.bind(this);
                this.submitHandler = this.submitHandler.bind(this);
                //this.searchPublic = this.searchPublic.bind(this);
        
            }
            

          /*  handleGithubUsername(e)
            {
                let formInput = e.target.value;
                this.setState({"githubUsername": formInput});
            }
            */
            handleFirstName(e)
            {
                let formInput = e.target.value;
                this.setState({"firstName": formInput});

            }

            handleLastName(e)
            {
            let formInput = e.target.value;
            this.setState({"lastName": formInput});
            }

            handleMiddleName(e)
            {
                let formInput = e.target.value;
                this.setState({"middleName": formInput});
            }


           async componentDidMount()
            {
                //load dataTime for footer
                let date = new Date();
                this.setState({footerYear:date});

                var currentDate = new Date();
                var currentYear = currentDate.getFullYear();
                this.setState({yearDate:currentYear});

                  //check if user is registered and logged in

            try{
                //get user access token
                let token = localStorage.getItem("token");
                                
                if((token === "noToken") || (token === null))
                {
                    this.setState({loggedInStatus:false});
                }
            
                let userDataResponse = await axios({
                method: "get",
                url: "http://mofehintolumumuni.com/gitserver/api/users/profile",
                headers: {"Authorization": "Bearer "+token}
                });
            
                let requestStatus = userDataResponse.data.status;
                //let payload = userDataResponse.data.data
            
                if(requestStatus !== "success")
                {
            
                    //Set loggedInStatus to false
                    this.setState({loggedInStatus:false});
            
                }
                
                if(requestStatus === "success")
                {
            
                    //Set loggedInStatus to true
                    this.setState({loggedInStatus:true});
            
                }
            
            
                }
                catch(error)
                {
                      //Set loggedInStatus
                      this.setState({loggedInStatus:false});
                }
    
            }
        
            componentDidUpdate()
            {
               // alert("componentDidUpdate");
            }
        
          
        
           async submitHandler(e)
            {
                e.preventDefault();
               
                this.setState({loadingPersonal:true});

                if((this.state.firstName !== null) && 
                (this.state.lastName !== null) && 
                (this.state.middleName !== null) && 
                (this.state.firstName !== "") && 
                (this.state.lastName !== "") && 
                (this.state.middleName !== ""))
                {

                  //get user access token
					let token = localStorage.getItem("token");
					
					if((token === "noToken") || (token === null))
					{
					alert("Unable to update user details");
					
                    }
                    else
                    {
                        //fire axios and update user details
                        try{
                            let response = await axios({
                                method: "put",
                                url: "http://mofehintolumumuni.com/gitserver/api/users/profile/edit",
                                data: {
                                    firstName: this.state.firstName,
                                    lastName: this.state.lastName,
                                    middleName: this.state.middleName
                                },
                                headers: {"Authorization": "Bearer "+token}
                                });
            
                                let status = response.data.status;
                                let message = response.data.message;

                                if(status === "success")
                                {
                                    this.setState({loadingPersonal:false});
                                    alert('Profile update successful');
                                    //set state
                                   
                                }
                                else
                                {
                                    this.setState({loadingPersonal:false});
                                    alert('Profile update not successful '+ message);
                                }

                        }
                        catch(error)
                        {
                            this.setState({loadingPersonal:false});
                            alert(`Profile update not successful`);
                        }
                            
                    }  

                }
                else
                {
                    	this.setState({loadingPersonal:false});
                    alert("Please fill form properly before submitting");
                }

            }
 
        
        
        render()
        {
            return (
    	<BrowserRouter>
      
     <div classNameName="App">
         <div className="header">
		<div className="container">
			<div className="logo">
   
				<Link to="/gitsearch/" >gitSearch</Link>
			</div>
			<div className="header-right">
			{(this.state.loggedInStatus) ?<Link  className="account"  to="/gitsearch/dashboard">Profile <i className="fa fa-user"></i></Link> : <Link  className="account"  to="/gitsearch/login">Login <i className="fa fa-chevron-circle-right"></i></Link> }
            
			<span className="active uls-trigger" data-toggle="modal" data-target="#mySearchModal">Public Search</span>

			<div className="selectregion">
				<button className="btn btn-primary" data-toggle="modal" data-target="#myModal">
				Developer Contact</button>
					<div className="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
					aria-hidden="true">
						<div className="modal-dialog modal-lg">
							<div className="modal-content">
								<div className="modal-header">
									<button type="button" className="close" data-dismiss="modal" aria-hidden="true">
										&times;</button>
									<h4 className="modal-title" id="myModalLabel">
										Developer Contact</h4>
								</div>
								<div className="modal-body">
								 <p><strong> DEVELOPER NAME: MOFEHINTOLU MUMUNI </strong></p>
                                 <p> <a className="account" href="http://www.mofehintolumumuni.com" target="_blank" rel="noopener noreferrer">DEVELOPER WEBSITE</a> <a className="account" href="https://github.com/Mofehintolu-mumuni" target="_blank"  rel="noopener noreferrer" >DEVELOPER GITHUB</a></p>
                                 <b></b>
                                <b></b>
                                <b></b>
                                <b></b>
                                  <p> <strong>DEVELOPER EMAIL 1: hello@mofehintolumumuni.com </strong> </p>
                                  <p> <strong>DEVELOPER EMAIL 2: mofehintolumumuni@gmail.com </strong> </p>
                                <b></b>
                                <b></b>
                           

								</div>
							</div>
						</div>
					</div>

					<div className="modal fade" id="infoModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
					aria-hidden="true">
						<div className="modal-dialog modal-lg">
							<div className="modal-content">
								<div className="modal-header">
									<button type="button" className="close" data-dismiss="modal" aria-hidden="true">
										&times;</button>
									<h4 className="modal-title" id="myModalLabel">
										Update Personal Information</h4>
                                        {(this.state.loadingPersonal) ? <h3>Loading <i className="fa fa-cogs" ></i> </h3> : null}
								</div>
								<div className="modal-body">
										<form onSubmit={this.submitHandler}>
												<div className="form-group">
													<input type="text" placeholder="First name"  onChange={this.handleFirstName} className="show-tick form-control" />
													<input type="text" placeholder="Middle name"  onChange={this.handleMiddleName} className="show-tick form-control" />
                                                    <input type="text" placeholder="Last name"  onChange={this.handleLastName} className="show-tick form-control" />
													

													<input type="submit" value="Submit" className="show-tick form-control" />
													
												</div>
										</form>
									
								</div>
							</div>
						</div>
					</div>


                    <div className="modal fade" id="mySearchModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
					aria-hidden="true">
						<div className="modal-dialog modal-lg">
							<div className="modal-content">
								<div className="modal-header">
									<button type="button" className="close" data-dismiss="modal" aria-hidden="true">
										&times;</button>
									<h4 className="modal-title" id="myModalLabel">
										TO ACCESS PUBLIC SEARCH CLICK <Link  className="account"  to="/gitsearch">HERE</Link></h4>
								</div>
								
							</div>
						</div>
					</div>
                    
                    </div>
                </div>
                </div>
            </div>
            <Route exact path="/gitsearch/" component={landingComponent}></Route>
            <Route exact path="/gitsearch/login" component={Login}></Route>
            <Route exact path="/gitsearch/register" component={register}></Route>
            <Route exact path="/gitsearch/forgotPassword" component={forgotPasswordComponent}></Route>
            <Route exact path="/gitsearch/changePassword/:hash" component={changePasswordComponent}></Route> 
            <Route exact path="/gitsearch/dashboard" component={dashboardComponent}></Route>    
            <Route exact path="/gitsearch/updates/:id/:username/:type" component={updatesComponent}></Route>  
            <Route exact path="/gitsearch/UpdatesIsssues/:id/:state/:issueName/:progLang" component={UpdatesIsssuesComponent}></Route>
            <Route exact path="/gitsearch/DeleteIsssues/:id" component={DeleteIsssuesComponent}></Route>
            <Route exact path="/gitsearch/DeleteUsers/:id" component={DeleteUsersComponent}></Route>
            <Route exact path="/gitsearch/DeleteOrgs/:id" component={DeleteOrgsComponent}></Route>
            
            <Route exact path="/gitsearch/email/verify/:token" component={verifyEmailComponent}></Route>    


            <Route exact path="/gitsearch/issues/view/:issue/:langauge/:state" component={IssuesViewComponent}></Route>


            <Route exact path="/gitsearch/users/events/:username" component={UsersEventsViewComponent}></Route>   
            <Route exact path="/gitsearch/users/repos/:username" component={UsersReposViewComponent}></Route>   
            <Route exact path="/gitsearch/users/gists/:username" component={UsersGistsViewComponent}></Route>   


            <Route exact path="/gitsearch/orgs/events/:orgname" component={OrgsEventsViewComponent}></Route>   
            <Route exact path="/gitsearch/orgs/repos/:orgname" component={OrgsReposViewComponent}></Route>  


            <Route exact path="/gitsearch/search/public/users/events/:username" component={UsersPublicEventsViewComponents}></Route>   
            <Route exact path="/gitsearch/search/public/users/repos/:username" component={UserPublicReposViewComponent}></Route>   
            <Route exact path="/gitsearch/search/public/users/gists/:username" component={UsersPublicGistsViewComponent}></Route>   
            

            <Route exact path="/gitsearch/search/public/orgs/events/:orgname" component={OrgsPublicEventsViewComponent}></Route>   
            <Route exact path="/gitsearch/search/public/orgs/repos/:orgname" component={OrgsPublicReposViewComponent}></Route>  
          

            <Route exact path="/gitsearch/search/public/issues/view/:issue/:langauge/:state" component={IssuesPublicViewComponent}></Route>
               <footer>
		
			<div className="footer-bottom text-center">
			<div className="container">
				
					<Link to="/gitsearch/">gitSearch</Link>
				
			
				<div className="copyrights">
					<p> © 2019 - {this.state.yearDate !== 2019 ? this.state.yearDate : null}  gitSearch. All Rights Reserved | Developed by  <a href="http://mofehintolumumuni.com/" target="_blank" rel="noopener noreferrer"> Mofehintolu Mumuni</a></p>
				</div>
				<div className="clearfix"></div>
			</div>
		</div>
		</footer>
        </div>
        </BrowserRouter>
         );
        }
        
        
        }
        
        
        
        
        export default App;
        
        
